import gql from 'graphql-tag'

// Query
export const GET_VEHICLE_INSPECTION_TEMPLATES = gql`
  query VehicleInspectionTemplates($filter: VehicleInspectionTemplatesFilter!) {
    vehicleInspectionTemplates(filter: $filter) {
      isSuccessful
      message
      status
      errorName
      errorCode
      vehicleInspectionTemplates {
        data {
          allVehicles
          createdAt
          createdBy {
            fullname
            userId
          }
          description
          hasInaccessibleTarget
          name
          templateId
          totalVehicles
          totalVgroups
          updatedAt
          updatedBy {
            fullname
            userId
          }
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
          actualTotal
        }
      }
    }
  }
`

export const GET_VEHICLE_INSPECTION_TEMPLATE = gql`
  query VehicleInspectionTemplate($filter: VehicleInspectionTemplateFilter!) {
    vehicleInspectionTemplate(filter: $filter) {
      isSuccessful
      message
      status
      errorName
      errorCode
      vehicleInspectionTemplate {
        allVehicles
        description
        name
        templateId
        sections {
          name
          questions {
            healthyLabel
            isRequired
            notePolicy
            photoPolicy
            question
            questionId
            sortOrder
            type
            unhealthyLabel
          }
          sectionId
          sortOrder
        }
        vehicles {
          id
          licensePlate
        }
        vgroups {
          id
          name
        }
        createdAt
        updatedAt
        updatedBy {
          fullname
          userId
        }
        createdBy {
          fullname
          userId
        }
        hasInaccessibleTarget
        totalVehicles
        totalVgroups
      }
    }
  }
`

// Mutation

export const CREATE_VEHICLE_INSPECTION_TEMPLATE = gql`
  mutation CreateVehicleInspectionTemplate($input: CreateVehicleInspectionTemplateInput!) {
    createVehicleInspectionTemplate(input: $input) {
      isSuccessful
      message
      status
      createVehicleInspectionTemplate {
        name
        templateId
      }
    }
  }
`

export const UPDATE_VEHICLE_INSPECTION_TEMPLATE = gql`
  mutation UpdateVehicleInspectionTemplate($input: UpdateVehicleInspectionTemplateInput!) {
    updateVehicleInspectionTemplate(input: $input) {
      isSuccessful
      message
      status
      updateVehicleInspectionTemplate {
        name
        templateId
      }
    }
  }
`

export const DELETE_VEHICLE_INSPECTION_TEMPLATE = gql`
  mutation DeleteVehicleInspectionTemplates($input: DeleteVehicleInspectionTemplatesInput!) {
    deleteVehicleInspectionTemplates(input: $input) {
      deleteVehicleInspectionTemplates {
        count
      }
      isSuccessful
      message
      status
    }
  }
`
